<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

// Read-only single-pin map for a public meeting point. Leaflet is lazy-imported
// on mount so it isn't in the initial bundle (matches LocationPickerModal).
const props = defineProps({
  lat:   { type: [Number, String], required: true },
  lng:   { type: [Number, String], required: true },
  label: { type: String, default: '' },
})

const mapEl = ref(null)
let map = null

onMounted(async () => {
  if (!mapEl.value) return
  const L = (await import('leaflet')).default
  await import('leaflet/dist/leaflet.css')
  // Leaflet's default marker icons break under bundlers — point at the CDN.
  delete L.Icon.Default.prototype._getIconUrl
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    iconUrl:       'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    shadowUrl:     'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  })

  const center = [Number(props.lat), Number(props.lng)]
  map = L.map(mapEl.value, { scrollWheelZoom: false }).setView(center, 15)
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxZoom: 19,
  }).addTo(map)
  const marker = L.marker(center).addTo(map)
  if (props.label) marker.bindTooltip(props.label)
})

onBeforeUnmount(() => { if (map) { map.remove(); map = null } })
</script>

<template>
  <div ref="mapEl" class="static-map" role="img" :aria-label="label"></div>
</template>

<style scoped>
.static-map {
  height: 16rem; width: 100%;
  border: 1px solid var(--line);
  border-radius: var(--radius-table, 0.75rem);
  overflow: hidden;
}
</style>
